<template>
  <div class="graph-card" role="data" title="Accountability Letter Grade" aria-describedby="letter-grade-description">
    <div class="graph-card-header" :style="{'background-color': this.headerColor}">
      <div class="g-heading">
        <h2>Accountability Letter Grade</h2>
        <p>{{ data.year }}</p>
      </div>
      <div
        class="tooltip-icon"
        tabindex="0"
        @mouseenter="toggleTooltip(1)"
        @mouseleave="toggleTooltip(0)"
        @keydown.enter="toggleTooltip(1)"
        @keyup.enter="toggleTooltip(0)">
      </div>
    </div>
    <div class="graph-card-body" :style="{'background-color': this.bodyColor}">
      <div class="flex-container" :style="{'background-color': this.headerColor}">
        <div class="letter-grade" :aria-label="'School recieved a ' + this.data.grade">{{ data.grade }}</div>
      </div>
      <div class="graph-card-footer">
        The state letter grade is required by state and federal laws, and is a measurement of overall school performance.
      </div>
      <div class="tooltip-text" ref="tooltip" aria-hidden="true">
        <p id="letter-grade-description">The state letter grade is determined by the following factors: proficiency on AzMERIT, graduation rates, student academic growth, English language proficiency and growth, and indicators that students are ready for success in the next school year.</p>
      </div>
    </div>

  </div> <!-- end graph-card -->
</template>

<script>
  export default {
    props: ['data', 'headerColor', 'bodyColor'],
    data() {
      return {

      }
    },
    methods: {
      toggleTooltip(value) {
        this.$refs.tooltip.style.left = value === 1 ? '0' : '99999px'
        this.$refs.tooltip.style.opacity = value
      }
    }
  }
</script>

<style lang="scss" scoped>
@import 'src/assets/_graphs.scss';
  .graph-card {
    .graph-card-body {
      // height: 350px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      .flex-container {
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        height: 250px;
        width: 250px;
      }
      .letter-grade {
        font-size: 11rem;
        font-family: sans-serif;
        // text-shadow: 0 0 15px #000;
      }
      .graph-card-footer {
        padding: 0px 10px;
        font-size: 1em;
        color: #000;
      }
    }
    @media (min-width: 1500px) {
      .graph-card-body {
        .graph-card-footer {
          font-size: 1.25em;
        }
      }
    }
  }
</style>
